import { render, staticRenderFns } from "./StatisticCardVerticalConfirmations.vue?vue&type=template&id=166eb7a4&"
import script from "./StatisticCardVerticalConfirmations.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalConfirmations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports